<template lang="pug">
#aligns
  .top-start.align-item
  .top-end.align-item
  .top-center.align-item

  .middle-start.align-item
  .middle-end.align-item
  .middle-center.align-item

  .bottom-start.align-item
  .bottom-end.align-item
  .bottom-center.align-item
</template>

<script>
export default {
  name: "aligns"
}
</script>

<style lang="scss" scoped>
#aligns {
  display: flex;
  z-index: -1;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  .align-item {
    width: 1px;
    height: 1px;
  }

  .top-start {
    position: absolute;
    top: 10px;
    left: 10px;
  }
  .top-end {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  .top-center {
    position: absolute;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
  }

  .middle-start {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 10px;
  }
  .middle-end {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 10px;
  }
  .middle-center {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 50%;
    transform: translateX(-50%);
  }

  .bottom-start {
    position: absolute;
    bottom: 10px;
    left: 10px;
  }
  .bottom-end {
    position: absolute;
    bottom: 10px;
    right: 10px;
  }
  .bottom-center {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
